import { render, staticRenderFns } from "./book-delay.vue?vue&type=template&id=8edbc488&"
import script from "./book-delay.vue?vue&type=script&lang=js&"
export * from "./book-delay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports